import Mute from "../../../javascripts/components/Mute";
import { highlightElementsInContainers } from "../../../javascripts/utils/highlighter";

function highlightKeywords() {
  highlightElementsInContainers(
    '.js-highlight-container',
    '.js-highlight',
    (container, _element) => {
      const keywordsStr = container.dataset.highlightKeyword;
      if (!keywordsStr) return [];
      return keywordsStr.split(' ').filter(k => k.trim().length > 0);
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  new Mute().addToggleMuteEvent();
  highlightKeywords();
});
